import request from '../utils/request';

export const sendMessage = ({
  firstName,
  lastName,
  email,
  phone,
  message
}: {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  message: string;
}) => {
  try {
    return request('/api/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        firstName,
        lastName,
        email,
        phone,
        message
      })
    });
  } catch (error) {
    throw new Error(error);
  }
};
